import { render, staticRenderFns } from "./MultiWarehouseDialog.vue?vue&type=template&id=8b545b4c&scoped=true"
import script from "./MultiWarehouseDialog.vue?vue&type=script&lang=js"
export * from "./MultiWarehouseDialog.vue?vue&type=script&lang=js"
import style0 from "./MultiWarehouseDialog.vue?vue&type=style&index=0&id=8b545b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b545b4c",
  null
  
)

export default component.exports